import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL

export const getUserAPI = async () => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.get(
      `${apiBaseUrl}/superAdmin/displayallUsers`,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    throw error
  }
}

//superAdmin/displayallEmployees

export const getEmployeeAPI = async payload => {
  try {
    const data = { id: payload.payload }
    console.log(data)
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/superAdmin/displayallEmployees`,
      data,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    throw error
  }
}


//superAdmin/ViewUserSubcription

export const getSubscriptionStatus = async payload => {
  try {
    const data = { id: payload.payload }
    console.log(data)
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/superAdmin/ViewUserSubcription`,
      data,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    throw error
  }
}

// users subcription plan

export const getSubscriptionUsersAPI = async () => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.get(
      `${apiBaseUrl}/superAdmin/userSubscriptionPlan`,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    throw error
  }
}